export default __webpack_public_path__ + "static/media/skype.4e9cf896.gif";